import { useQuery } from '@tanstack/solid-query'
import { createMemo } from 'solid-js'
import { getServiceClient } from '~/lib/api'
import { inStep } from '~/lib/load-failure'
import {
  normalizeFocusChallenges,
  type FocusChallengesResponse,
  type NormalizedFocusChallenges,
} from '~/lib/focus-challenge-model'
import { devOverride } from '~/store/dev-override'

export * from '~/lib/focus-challenge-model'

export const focusChallengesKey = ['focus-challenges'] as const

export function useFocusChallengesQuery() {
  return useQuery(() => ({
    queryKey: focusChallengesKey,
    queryFn: () =>
      inStep('load_challenges', async () => {
        const { client, userId } = await getServiceClient()
        return await client
          .get(`challenge/users/${userId}/progresses/focus`, {
            // Include Plus-challenge progresses for everyone (subscribers and
            // non-subscribers) so they show as an upsell.
            searchParams: { include_subscription_progress: 'true' },
          })
          .json<FocusChallengesResponse>()
      }),
  }))
}

export function useFocusChallenges() {
  const query = useFocusChallengesQuery()
  const normalized = createMemo<NormalizedFocusChallenges | null>(() => {
    const data = query.data
    if (!data) return null
    return normalizeFocusChallenges(data)
  })
  return {
    query,
    data: () => devOverride.apply(normalized()),
  }
}
